import { createSlice } from "@reduxjs/toolkit";


const globalFilterSlice = createSlice({
  name: "globalFilter",
  initialState: { selectList: null, selectedDataList: [] },
  reducers: {
    selectList: (state, action) => {
      state.selectedDataList = action.payload;
    },
  },
});

export const { selectList } = globalFilterSlice.actions;

// Export reducer
export default globalFilterSlice.reducer;
